import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFrontendConfig } from "../config/useFrontendConfig";

export const ProductTranslationsProvider: FC = () => {
	const { productTranslations } = useFrontendConfig();
	const { i18n } = useTranslation();

	useEffect(() => {
		productTranslations.forEach((productTranslation) => {
			i18n.addResourceBundle(
				productTranslation.locale,
				"translation",
				JSON.parse(productTranslation.value),
				true,
				true,
			);
		});
	}, [i18n, productTranslations]);

	return null;
};
